/**
 * Textauswahl und Textfokus eines Zettels aufgeben — pro forma, ohne
 * Vorbedingung.
 *
 * Nach dem Bearbeiten kann eine Markierung stehen bleiben: Der Klick daneben
 * landet auf React Flows Fläche, die `mousedown` abfängt (`preventDefault`
 * fürs Schieben und Aufziehen) — und genau dieses Ereignis ist es, das der
 * Browser sonst zum Löschen einer Auswahl und zum Fokuswechsel nimmt. Der
 * Zettel ist dann abgewählt, das Wort in ihm aber weiter blau, und Entf läuft
 * ins Feld statt zum Zettel.
 *
 * **Deshalb ohne Bedingungen:** Jeder Ausstieg aus dem Bearbeiten-Modus und
 * jede Abwahl rufen das hier — egal, ob eine Auswahl offen ist, wo sie liegt
 * oder ob das Feld den Fokus hat. Beim Verlassen eines Zettels gibt es keine
 * fremde Auswahl, die zu schonen wäre. Bedingte Fassungen davon griffen in
 * der App nicht (siehe `.claude/tasks/canvas-text-selection-on-exit.md`).
 *
 * Und zweimal: sofort und im nächsten Frame. Nach Reacts Re-Render (das Feld
 * wird schreibgeschützt) kann Chromium die Auswahl neu zeichnen; der zweite
 * Durchlauf räumt auch das ab.
 */
export function releaseTextSelection(field: HTMLTextAreaElement | HTMLInputElement | null | undefined): void {
  const release = () => {
    if (field && field.isConnected) {
      try { field.setSelectionRange(0, 0) } catch { /* Feldtypen ohne Auswahl */ }
      if (document.activeElement === field) field.blur()
    }
    const selection = window.getSelection?.()
    if (selection && selection.rangeCount > 0) selection.removeAllRanges()
  }
  release()
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(release)
}
